<template>
  <div>
    <div class="title">如何填写发票内容？</div>
    <div class="content-info">
      <p class="txt1">
        发票抬头：抬头要与营业执照注册名称一致
        <br />发票内容：内容必须与实际销售情况一致
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
